export default __webpack_public_path__ + "static/alephbeta-black-logo-cec96ec8e9b5b2a1c2d976029f2359ea.svg";